import { Injectable } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppOptions, FrameworkService, AppService } from '@gsp-sys/rtf-common';
import { IRtShowEntity } from '../entity/IRtShowEntity';
import { BifMonitorConstant } from '../entity/BifMonitorConstant';
import { ProcessFilterConditionArgs } from '../entity/ProcessFilterConditionArgs';
import { RtBillProcessListResult } from '../entity/RtBillProcessListResult';
import { RtShowEntity } from '../entity/RtShowEntity';

@Injectable()
export class ProcessListHelpService {
  private readonly baseUrl = "/api/runtime/aif/v1.0/rtbillprocess";

  constructor(
    private appService: AppService,
    private frameworkService: FrameworkService,
    private httpService: HttpService,
  ) {
  }

  public openBifManagerApp(entity: IRtShowEntity) {
    const map = new Map();
    map.set("id", entity.id);
    map.set("type", entity.bifMetadataType);
    map.set("srcFuncId", BifMonitorConstant.bifDiagnostorFuncId);
    const opt: AppOptions = {
      funcId: BifMonitorConstant.bifManagerFuncId,
      appId: BifMonitorConstant.bifMonitorAppId,
      appEntrance: BifMonitorConstant.bifManagerAppEntrance,
      appType: "menu",
      entityParams: {},
      queryStringParams: map,
      tabId: entity.id,
      tabName: entity.name
    };
    this.frameworkService.openMenu(opt);
  }

  public getDatagridData(args: ProcessFilterConditionArgs): Observable<RtBillProcessListResult> {
    // 参数深拷贝
    let temp = null;
    if (args) {
        temp = new ProcessFilterConditionArgs();
        temp.LoadFromJsonObject(args.ConvertToJsonObject());
    }
    args = temp;
    // 将特殊字符转义
    if (args && args.name != null && args.name.hasValue && args.name.value) {
        args.name.value = args.name.value.replace(/[%_]/g, "\\$&");
    }
    const body = args.ConvertToJson();
    let data$: Observable<any> = null;
    //有业务种类参数时不分页
    if (args.bizType != null) {
      data$ = this.httpService.post(`${this.baseUrl}/getpatch`, body);
      return data$.pipe(
        map(
          (res: any) => {
            const listRes = new RtBillProcessListResult();
            listRes.entities = res.map(elt => {
              const e = new RtShowEntity();
              e.LoadFromJsonObject(elt);
              return e;
            });
            return listRes;
          }
        )
      );
    } else {
      data$ = this.httpService.post(`${this.baseUrl}/getpagedpatch`, body);
      return data$.pipe(
        map(
          (res: any) => {
            const listRes = new RtBillProcessListResult();
            listRes.LoadFromJsonObject(res);
            return listRes;
          }
        )
      );
    }
  }

  /**
   * 根据流程编号查询流程名称
   * @param code
   * @returns
   */
  public getProcessNameByCode(code: string): Observable<any> {
    return this.httpService.request("GET", `/api/runtime/aif/v1.0/rtbillcreationprocess/getname/${code}`, { responseType: 'text' });
  }
}
